import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ScholarshipAwardDurationStoreActions,
  ScholarshipAwardDurationStoreSelectors,
  ScholarshipAwardDurationStoreReducer,
} from './index';
import { ScholarshipAwardDurationDto } from '@cradua/data';

@Injectable()
export class ScholarshipAwardDurationFacade {
  constructor(
    private store: Store<
      ScholarshipAwardDurationStoreReducer.ScholarshipAwardDurationPartialState
    >
  ) {}

  scholarshipAwardDurationRecord$ = this.store.select(
    ScholarshipAwardDurationStoreSelectors.getSelected
  );
  scholarshipAwardDurationRecordError$ = this.store.select(
    ScholarshipAwardDurationStoreSelectors.getScholarshipAwardDurationError
  );

  getselected() {
    return this.store.select(
      ScholarshipAwardDurationStoreSelectors.getSelected
    );
  }

  get isLoadingScholarshipAwardDuration() {
    this.store.dispatch(
      ScholarshipAwardDurationStoreActions.loadScholarshipAwardDuration()
    );
    return this.store.select(
      ScholarshipAwardDurationStoreSelectors.loadingScholarshipAwardDuration
    );
  }

  get loadScholarshipAwardDuration() {
    this.store.dispatch(
      ScholarshipAwardDurationStoreActions.loadScholarshipAwardDuration()
    );
    return this.store.select(
      ScholarshipAwardDurationStoreSelectors.getAllScholarshipAwardDuration
    );
  }

  addScholarshipAwardDuration(
    newScholarshipAwardDuration: ScholarshipAwardDurationDto[]
  ) {
    this.store.dispatch(
      ScholarshipAwardDurationStoreActions.addScholarshipAwardDuration({
        newScholarshipAwardDuration,
      })
    );
  }

  updateScholarshipAwardDuration(
    updateScholarshipAwardDuration: ScholarshipAwardDurationDto[]
  ) {
    this.store.dispatch(
      ScholarshipAwardDurationStoreActions.updateScholarshipAwardDuration({
        updateScholarshipAwardDuration,
      })
    );
  }

  removeScholarshipAwardDuration(ids: string[]) {
    this.store.dispatch(
      ScholarshipAwardDurationStoreActions.removeScholarshipAwardDuration({
        ids,
      })
    );
  }
}
